import React, { Component, Fragment } from 'react'

import { checkUserTokenUtil } from '../../utils/utils';

import Breadcrumb from '../common/breadcrumb';

import * as otherApi from './../../api/other';

export class ManageClientTestimonials extends Component {

    constructor(props) {
        super(props)

        this.state = {
            testimonials: [],
            name: '',
            content: '',
            job: 'Diamond Leader',
            image: null
        }
    }

    componentDidMount = async () => {
        const checkUserTokenUtilRes = await checkUserTokenUtil();
        if (checkUserTokenUtilRes) {
            let spinner = document.getElementById("spinneranimid");
            spinner.style.display = "block";
            await otherApi.fetchClientTestimonials()
                .then(res => {
                    if (res.status == 200) {
                        this.setState({ testimonials: res.data })
                    } else {
                        alert('Error Occured .. Please Try after some time')
                    }
                    spinner.style.display = "none";
                })
                .catch((err) => {
                    alert('Error Occured .. Please Try after some time')
                    spinner.style.display = "none";
                })
        }
    }

    setImage = e => {
        let file = e.target.files[0];
        if (file != undefined) {
            if (
                file.type.toLowerCase() != 'image/jpg' &&
                file.type.toLowerCase() != 'image/jpeg' &&
                file.type.toLowerCase() != 'image/png'
            ) {
                this.setState({ image: null }, () => {
                    alert('Please upload a valid Image file..!')
                })
            } else {
                var _URL = window.URL || window.webkitURL;
                var img = new Image();
                var objectUrl = _URL.createObjectURL(file);
                const scope = this
                img.onload = function () {
                    if (this.width != 500 || this.height != 500 || file.size > 512000) {
                        scope.setState({ image: null }, () => {
                            alert('Please make sure the image is 500px x 500px and under 500 kb..!')
                        })
                    } else {
                        scope.setState({ image: file })
                    }
                    _URL.revokeObjectURL(objectUrl);
                };
                img.src = objectUrl;
            }
        } else {
            this.setState({ image: null })
        }
    }

    addTestimonial = async (e) => {
        e.preventDefault();

        if (this.state.image == null) {
            alert('Please re-select the image ..!')
        } else {
            if (window.confirm('Do you want to add the Testimonial ?')) {

                let spinner = document.getElementById("spinneranimid");
                spinner.style.display = "block";

                let dataToUpload = {
                    content: '“ ' + this.state.content + ' ”',
                    name: this.state.name,
                    job: this.state.job
                }

                const formData = new FormData();
                formData.append('files', this.state.image)
                formData.append('dataToUplaod', JSON.stringify(dataToUpload))

                await otherApi.addClientTestimonial(formData)
                    .then(res => {
                        if (res.status == 200) {
                            alert('Testimonial Added ..!')
                            spinner.style.display = "none";
                            window.location.reload();
                        } else {
                            alert('Something went wrong')
                            spinner.style.display = "none";
                            window.location.reload();
                        }
                    })
                    .catch((err) => {
                        alert('Something went wrong')
                        spinner.style.display = "none";
                        window.location.reload();
                    })

            }
        }

    }

    deleteTestimonial = async (e, id) => {
        e.preventDefault();

        if (window.confirm('Do you want to delete the Testimonial ?')) {
            let spinner = document.getElementById("spinneranimid");
            spinner.style.display = "block";
            await otherApi.deleteClientTestimonial({ id: id })
                .then((res) => {
                    if (res.status == 200) {
                        alert("Testimonial Deleted");
                        window.location.reload();
                        spinner.style.display = "none";
                    } else if (res.status == 405 && res.error == 'Testimonial Does Not Exists') {
                        alert('This Testimonial does not exists..!')
                        window.location.reload();
                        spinner.style.display = "none";
                    } else {
                        alert('Error Occured.. Please Try after some time')
                        window.location.reload();
                        spinner.style.display = "none";
                    }
                })
                .catch((err) => {
                    alert('Error Occured.. Please Try after some time')
                    window.location.reload();
                    spinner.style.display = "none";
                })
        }
    }

    render() {
        return (
            <Fragment>
                <Breadcrumb title="Manage Testimonials" parent="Utilities" />

                <div id="spinneranimid" className="overlay-spinner">
                    <div className="cssload-whirlpool" />
                </div>

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5 className='mb-3'>Add Testimonial</h5>
                                    <form onSubmit={this.addTestimonial}>
                                        <label htmlFor='name'>Name* :</label>
                                        <input style={{ maxWidth: '450px' }} className="form-control mb-4" id="name" name="name" onChange={(e) => this.setState({ name: e.target.value })} required />
                                        <label htmlFor='content'>Testimonial* :</label>
                                        <textarea style={{ maxWidth: '450px' }} className="form-control mb-4" id="content" name="content" onChange={(e) => this.setState({ content: e.target.value })} required />
                                        {/* <label htmlFor='job'>Post* :</label>
                                        <input style={{ maxWidth: '450px' }} className="form-control mb-4" id="job" name="job" onChange={(e) => this.setState({ job: e.target.value })} required /> */}
                                        <label className='mt-1'>Select the Image*:</label>
                                        <input className="form-control" id="image" name="image" type="file" onChange={this.setImage} required />

                                        <button type="submit" className="btn btn-primary mt-3">
                                            Add Testimonial
                                        </button>

                                    </form>
                                </div>
                                <div className="card-body order-datatable lists-custom">

                                    {this.state.testimonials.length > 0 ?
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Sr. No.</th>
                                                    <th>Name</th>
                                                    <th>Image</th>
                                                    <th>Testimonial</th>
                                                    <th>Delete</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.testimonials.map((item, index) =>
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.name}</td>
                                                        <td className='pt-3 pb-3 pr-3 pl-3'><img style={{ width: '100px', borderRadius: '100%' }} src={`https://shivshahinetwork.com/assets/images/testimonials/${item.image}`} alt={'image' + index} /></td>
                                                        <td style={{ textAlign: 'start' }}>{item.content}</td>
                                                        <td>
                                                            <a href='#' onClick={(e) => this.deleteTestimonial(e, item.id)} className='aicon'><i className="fa fa-close" /></a>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>

                                        :
                                        <div>
                                            <p>No Link has been Added Yet.</p>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        )

    }
}

export default ManageClientTestimonials;
